module.exports = __webpack_public_path__ + "media/whale sharks/dock-ef7f1293.jpg";